import { recipe } from "@vanilla-extract/recipes";
import { responsive } from "@huub-web/ui/utils/responsive";

export const containerStyle = recipe({
  base: {
    position: "absolute",
    overflow: "hidden",
    pointerEvents: "none",
    width: "100%",
    height: "100%",
  },
  variants: {
    variant: {
      default: {},
      banner: {
        scale: 2.75,
      },
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export const graphicStyle = recipe({
  base: {
    position: "absolute",
    top: "50%",
    left: "50%",
    aspectRatio: "1/1",
    ...responsive({
      base: {
        vars: {
          "--base": "60%",
          "--modifier": "20%",
        },
      },
      s: {
        vars: {
          "--base": "80%",
        },
      },
      l: {
        vars: {
          "--base": "100%",
          "--modifier": "30%",
        },
      },
    }),
  },
  variants: {
    position: {
      a: {
        height: "calc(var(--base) + var(--modifier) * 2)",
      },
      b: {
        height: "calc(var(--base) + var(--modifier))",
      },
      c: {
        height: "calc(var(--base))",
      },
      d: {
        height: "calc(var(--base) - var(--modifier))",
      },
    },
  },
});
